import React from 'react';
// import { Link } from 'react-router-dom';
import '../styles/ProductCard.css';

const ProductCard = ({ product }) => {
  return (
    <div className="product-card">
      
      <img src={product.image} alt={product.name} className='image' />
      <h4>{product.name}</h4>
      {/* <Link to={`/product/${product.id}`} className="quote-btn">View & Request Quote</Link> */}
    </div>
  );
};

export default ProductCard;
